exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-text-field--outlined[data-v-6dde0d20] .v-select__selection{color:#0057b8}.v-text-field--outlined[data-v-6dde0d20] .v-label{color:#0057b8;font-weight:700}.v-text-field--outlined[data-v-6dde0d20] fieldset{border-color:#0057b8}", ""]);

// exports
